module.exports = __webpack_public_path__ + "static/img/73100D_1_2_C_20240618_LC.d20fd67.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/73100D_1_2_C_20240618_LC.png
// module id = cdT1
// module chunks = 0